export const baseColors = {
  primaryBackground: '#FFFFFF',
  onImageBackground: '#FFFFFF',
  onIconsAndTextButtons: '#FFFFFF',
  onIconsAndTextButtonsVariant: '#FFFFFF',
  secondaryBackground: '#F8FCFD',
  selectedAndDetailBackground: '#DEEDF3',
  borderLine: '#BAE3E6',
  placeholderText: '#BAE3E6',
  menuBackground: '#0D3B4B',
  currentStep: '#0D3B4B',
  onSecondaryAndDetailBackground: '#0D3B4B',
  hoverMenuBackground: '#204C5B',
  mainFocused: '#06888F',
  highlight: '#E79211',
  tradingDown: '#E79211',
  tradingUp: '#E79211',
  off: '#CEE1EC',
  lower: '#B5B7CA',
  footerBackground: '#0D3B4B',
  onFooterBackground: '#FFFFFF',
  popupWindow: '#0D3B4B',
  popupWindowTitle: '#FFFFFF',
  iconsOnFooterBackground: '#06888F',
  primaryDisabledBackground: '#E6EFF4',
  secondaryDisabledBackground: '#F8FCFD',
  primaryDisabledText: '#F8FCFD',
  secondaryDisabledText: '#c5e0ed',
  scrollOnDetailBackground: '#BBD6E0',
  scrollOnPrimaryBackground: '#DDDEE8',
  infoBackground: '#F2F4F9',
  nextStep: '#DBE3F6',
  previousStep: '#739CAB',
  iconsOnMenuBackground: '#739CAB',
  mainFocusedSoothing: '#E2F6F7',
  highlightSoothing: '#F8F0E3',
  pillBorder: '#4BA1BF',
  pillBackgroundGloomy: '#97CBE0',
  pillBackgroundLight: '#EBF7FA',
  dividerOnPrimaryBackground: '#EBF7FA',
  label: '#739CAB',
  homePageBackground: '#FFFFFF',
  onHomePageBackground: '#0D3B4B',
  refreshButton: '#0D3B4B',
  dashboardDivider: '#D1D3D8',
  star: '#FEB71C',
  up: '#36A41D',
  down: '#DC4040',
  inert: '#9FC9DA',
  scrollOnInfoBackground: '#DDDEE8',
  actionBar: '#F8F9FF',
  onInfoBackground: '#0D3B4B',
  onPrimaryBackground: '#0D3B4B',
  lockedBackground: 'rgba(13, 59, 75, 0.65)',
  hoverHighlight: '#FFB059',
  variantOnInfoBackground: '#0D3B4B',
  variantOnPrimaryBackground: '#0D3B4B',
  graphBackground: '#EBF7FA',
  disabledAndHoverOnInfoBackground: '#DDDEE8',
  disabledOnPrimaryBackground: '#DDDEE8',
  iconsSelectedOnMenu: '#E79211',
  selectedBarOnMenu: '#E79211',
  selectedTextButtonMenu: '#06888F',
  newsBackground: '#E7EDF3',
};
